import { makeStyles } from "@material-ui/core";

export const AddorEditGlobalTriggerStyles = makeStyles({
  root: {
    color:'var(--dark_blue)'
  },
  titleHeader: {
    fontSize: "20px",
  },
  iconsButton: {
    borderRadius: "12px",
    padding: "8px",
    "&:hover,&:focus": {
      backgroundColor: "white",
    },
  },
  selectedFolderIcon: {
    backgroundColor: "white",
  },
  checkIconColor: {
    color: "white",
    height: "30px",
    width: "30px",
  },
  outerIconColor: {
    height: "50px",
    width: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    cursor: "pointer",
  },
  innerIconColor: {
    height: "40px",
    width: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    border: "2px solid white",
  },
  errorStyle: {
    border: "1px solid red !important",
    borderRadius: "4px",
  },
  errorText: {
    color: "red",
  },
  saveButton: {
    backgroundColor: "#3C7EF3 !important",
    fontWeight: "600 !important",
    color: "white !important",
    minWidth: "fit-content !important",
    textTransform:'capitalize !important',
    "&:hover, &:focus": {
      backgroundColor: "#3C7EF3 !important",
      color: "white",
    },
  },

  triggerSettingsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px",
    borderBottom: "1px solid #d3d3d3",
  },
  
  contentWrapper: {
    display: "flex",
    gap: '0 !important'
  }
});

